import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { STATS } from "@/lib/content";

const Count = ({ to }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [n, setN] = useState(to);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, to, { duration: 1.6, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, to]);
  return <span ref={ref}>{n}</span>;
};

export const Stats = () => (
  <div data-testid="stats-strip" className="grid grid-cols-2 border-y border-line md:grid-cols-4">
    {STATS.map((s, i) => (
      <div key={s.label} className={`px-6 py-8 md:px-10 ${i % 2 ? "border-l border-line" : ""} ${i > 1 ? "border-t border-line md:border-t-0" : ""} ${i === 2 ? "md:border-l" : ""}`}>
        <p className="font-display text-5xl font-semibold tracking-tight text-white md:text-6xl" data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}><Count to={s.value} /></p>
        <p className="eyebrow mt-2">{s.label}</p>
      </div>
    ))}
  </div>
);
